import { useCallback } from 'react';

/**
 * useCanvasContextMenu Hook
 * 
 * Provides handlers for creating nodes at specific positions from the canvas context menu.
 * State management is handled externally (in useFlowchartCore).
 */
export function useCanvasContextMenu({
  setTaskPosition,
  onAddTask,
  pasteAtPosition,
  setSelectedNodes,
}) {
  // Add a new mission at the specified position
  const handleAddMissionAtPosition = useCallback((position) => {
    const taskId = onAddTask?.(null, null, 'task', { position });
    if (taskId && setTaskPosition) {
      setTaskPosition(taskId, position);
    }
    if (taskId && setSelectedNodes) {
      setSelectedNodes(new Set([taskId]));
    }
  }, [onAddTask, setSelectedNodes, setTaskPosition]);

  // Add a new decision at the specified position
  const handleAddDecisionAtPosition = useCallback((position) => {
    const taskId = onAddTask?.(null, null, 'decision', { position });
    if (taskId && setTaskPosition) {
      setTaskPosition(taskId, position);
    }
    if (taskId && setSelectedNodes) {
      setSelectedNodes(new Set([taskId]));
    }
  }, [onAddTask, setSelectedNodes, setTaskPosition]);

  const handleAddWaitAtPosition = useCallback((position) => {
    const taskId = onAddTask?.(null, null, 'wait', { position });
    if (taskId && setTaskPosition) {
      setTaskPosition(taskId, position);
    }
    if (taskId && setSelectedNodes) {
      setSelectedNodes(new Set([taskId]));
    }
  }, [onAddTask, setSelectedNodes, setTaskPosition]);

  // Paste at the specified position
  const handlePasteAtPosition = useCallback((position) => {
    pasteAtPosition?.(position);
  }, [pasteAtPosition]);

  return {
    handleAddMissionAtPosition,
    handleAddDecisionAtPosition,
    handleAddWaitAtPosition,
    handlePasteAtPosition,
  };
}

export default useCanvasContextMenu;
